export default __webpack_public_path__ + "static/media/blue_down_arrow.2396dd4c.svg";